<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.Number" clearable></el-input>
      </el-form-item>
      <el-form-item label="聚能谷桩名">
        <el-input placeholder="请输入聚能谷桩名" v-model="filter.EName" clearable></el-input>
      </el-form-item>

      <el-form-item label="设备服务">
        <el-select class="selScale" v-model="filter.InterfaceType">
          <el-option label="--全部--" value=""> </el-option>
          <el-option label="聚能谷Old" value="0"> </el-option>
          <el-option label="统建统服" value="1"> </el-option>
          <el-option label="聚能谷New" value="2"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column label="资产码" prop="NumberBox" width="220" align="center">
        <template slot-scope="{ row }">
          <div class="show_assets_code" @click="showTripletDetail(row.NumberBox)">{{ row.NumberBox }}</div>
        </template>
      </el-table-column>

      <el-table-column label="充电桩名" prop="EName" width="180"></el-table-column>
      <el-table-column label="所属站点" prop="regionName"></el-table-column>
      <el-table-column label="设备服务" prop="InterfaceTypeName"></el-table-column>
      <el-table-column label="类别" prop="TypeName"></el-table-column>
      <el-table-column label="状态" prop="State" align="center" width="80">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.State == '正常'">{{ row.State }}</el-tag>
          <el-tag type="info" v-else>{{ row.State }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="智能托管" prop="dis_smart_order" width="100">
        <template slot-scope="{ row }">
          <el-tag type="info" v-if="row.dis_smart_order">禁用</el-tag>
          <el-tag type="success" v-else>正常</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="预约下单" prop="dis_pre_order" width="100">
        <template slot-scope="{ row }">
          <el-tag type="info" v-if="row.dis_pre_order">禁用</el-tag>
          <el-tag type="success" v-else>正常</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="购买保险" prop="dis_insurance" width="100">
        <template slot-scope="{ row }">
          <el-tag type="info" v-if="row.dis_insurance">禁用</el-tag>
          <el-tag type="success" v-else>正常</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="Createtime"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="140px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增or修改充电充电桩 -->
    <el-dialog :visible.sync="visible.editGroup" :title="isUpdate ? $t('groupmanage.editortitle') : $t('groupmanage.appendtitle')" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="充电桩名" prop="name" label-width="20%">
              <el-input placeholder="请输入充电充电桩名" v-model="form.name" maxlength="30" show-word-limit />
            </el-form-item>

            <el-row type="flex" justify="left" class="custom-label">
              <el-col :span="16">
                <el-form-item label="聚能谷桩名" prop="EName" label-width="30%">
                  <div @click="onSelectPile">
                    <el-input :disabled="isUpdate" v-model="form.EName" readonly placeholder="请选择聚能谷桩" suffix-icon="el-icon-more"></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="相别" prop="term">
                  <el-select v-model="form.term">
                    <el-option v-for="item in termItems" :label="item.label" :value="item.Id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="地址" prop="address" label-width="20%">
              <el-input placeholder="请输入地址" v-model="form.address" />
            </el-form-item>
            <el-form-item label="描述" prop="remark" label-width="20%">
              <el-input placeholder="请输入描述" v-model="form.remark" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editGroup = false">{{ $t("groupmanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t("groupmanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>
    <!-- 充电充电桩选择框 -->
    <select-pile :show.sync="visible.pile" @confirm="confirmSelectpile"></select-pile>
    <tripletDetail ref="tripletDetail"></tripletDetail>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import selectPile from "./components/select-pile.vue"
import tripletDetail from "../control/_triplet_detail.vue"
import { getPowerChargePileList, GetJngPilePageList } from "@/api/dev_archive"
import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { selectPile, tripletDetail },
  data() {
    return {
      visible: {
        editGroup: false,
        pile: false
      },
      tableData: [],
      termItems: [
        { label: "A相", Id: "A" },
        { label: "B相", Id: "B" },
        { label: "C相", Id: "C" }
      ],
      form: {
        name: "",
        EName: "",
        maindba_equipmentbox_id: "",
        term: "",
        address: "",
        remark: ""
      },
      formRules: {},
      filter: {
        Number: "",
        EName: "",
        InterfaceType: ""
      },
      loading: false,
      isUpdate: true,
      gid: "" // 充电充电桩ID
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.formRules = {
      EName: [{ required: true, message: "请选择充电桩", trigger: "change" }],
      name: [{ required: true, message: "请填写充电桩名", trigger: "change" }]
    }

    this.getData()
  },
  methods: {
    showTripletDetail(assetsCode) {
      this.$refs.tripletDetail.showTripletInfo(assetsCode)
    },
    async onUpdate(row) {
      this.visible.editGroup = true
      this.isUpdate = true

      this.form.name = row.name
      this.form.EName = row.EName
      this.form.maindba_equipmentbox_id = row.maindba_equipmentbox_id
      this.form.term = row.term
      this.form.address = row.address
      this.form.remark = row.remark
      this.gid = row.ID
    },

    onDelete(row) {
      this.$confirm("确定要删除该充电桩吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {})
        .catch(() => {})
    },

    confirmSelectpile(item) {
      this.visible.pile = false
      this.form.maindba_equipmentbox_id = item.ID
      this.form.EName = item.EName
    },

    onSelectPile() {
      if (this.isUpdate) {
        return
      }
      this.visible.pile = true
    },

    getData() {
      this.loading = true
      GetJngPilePageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        asset_code: this.filter.Number || null,
        name: this.filter.EName || null,
        InterfaceType: this.filter.InterfaceType || null
      })
        .then((res) => {
          // 处理表格数据
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },

    onAdd() {
      this.visible.editGroup = true
      this.isUpdate = false
      this.form = this.$options.data().form
    },

    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          const reqData = {
            name: this.form.name,
            maindba_equipmentbox_id: this.form.maindba_equipmentbox_id,
            term: this.form.term,
            address: this.form.address,
            remark: this.form.remark
          }
          addPowerChargePile(reqData)
            .then((res) => {
              this.$message.success(`${this.$t("publics.addedsuccessful")}`)
              this.visible.editGroup = false
              this.toFilter()
            })
            .finally(() => {
              loading.close()
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
